// extracted by css-extract-rspack-plugin
export default {"celebrate":"Celebrate-module__celebrate__BMHSa","copilotRun":"Celebrate-module__copilotRun__qYdDf"};